import { get } from 'lodash';

export const selectHomeownerOnboarding = state => get(state, ['homeownerOnboarding'], []);
